(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["radian-vortex-doyoo"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initRadianVortex = (root) => {
    if (!root || root.dataset.rvReady === 'true') return;
    root.dataset.rvReady = 'true';

    const mainImage = root.querySelector('.rv-main-image');
    const thumbs = Array.from(root.querySelectorAll('[data-rv-thumb]'));
    const variantButtons = Array.from(root.querySelectorAll('[data-rv-variant]'));
    const variantInput = root.querySelector('[data-rv-variant-input]');
    const variantLabel = root.querySelector('[data-rv-variant-label]');
    const price = root.querySelector('[data-rv-price]');
    const compare = root.querySelector('[data-rv-compare]');
    const stock = root.querySelector('[data-rv-stock]');
    const atc = root.querySelector('[data-rv-atc]');
    const stickyPrice = root.querySelector('[data-rv-sticky-price]');
    const productForm = root.querySelector('.rv-product-form');
    let currentIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));

    const setImage = (src, index) => {
      if (mainImage && src) {
        /* Shopify image_tag creates srcset; remove it so a variant image change is visible immediately. */
        mainImage.removeAttribute('srcset');
        mainImage.removeAttribute('sizes');
        mainImage.src = src;
      }
      if (Number.isInteger(index) && index >= 0) {
        currentIndex = index;
        thumbs.forEach((thumb, i) => thumb.classList.toggle('is-active', i === index));
      }
    };

    const selectVariant = (button) => {
      if (!button) return;

      variantButtons.forEach((item) => {
        item.classList.remove('is-active');
        item.setAttribute('aria-selected', 'false');
      });
      button.classList.add('is-active');
      button.setAttribute('aria-selected', 'true');

      const variantId = button.dataset.variantId || '';
      const variantTitle = button.dataset.variantTitle || '';
      const variantPrice = button.dataset.variantPrice || '';
      const variantCompare = button.dataset.variantCompare || '';
      const available = button.dataset.variantAvailable === 'true';

      if (variantInput) {
        variantInput.value = variantId;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (variantLabel) variantLabel.textContent = variantTitle;
      if (price) price.textContent = variantPrice;
      if (stickyPrice) stickyPrice.textContent = variantPrice;

      if (compare) {
        compare.textContent = variantCompare;
        compare.hidden = !variantCompare;
      }

      if (stock) stock.textContent = available ? 'In stock — ready to order' : 'Currently unavailable';
      if (atc) {
        atc.disabled = !available;
        atc.textContent = available ? 'ADD TO CART' : 'SOLD OUT';
      }

      if (button.dataset.variantImage) setImage(button.dataset.variantImage);

      /* Keep the URL in sync with the selected Shopify variant without reloading the page. */
      if (variantId && window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.history.replaceState({}, '', url.toString());
      }

      /* Let any theme/app code listening for variant changes react as well. */
      root.dispatchEvent(new CustomEvent('radian:variant-change', {
        bubbles: true,
        detail: { id: variantId, title: variantTitle, available }
      }));
      if (productForm) productForm.dispatchEvent(new Event('change', { bubbles: true }));
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => setImage(thumb.dataset.rvSrc, index));
    });

    root.querySelector('[data-rv-prev]')?.addEventListener('click', () => {
      if (!thumbs.length) return;
      const next = (currentIndex - 1 + thumbs.length) % thumbs.length;
      setImage(thumbs[next].dataset.rvSrc, next);
    });

    root.querySelector('[data-rv-next]')?.addEventListener('click', () => {
      if (!thumbs.length) return;
      const next = (currentIndex + 1) % thumbs.length;
      setImage(thumbs[next].dataset.rvSrc, next);
    });

    /* Delegation is more reliable in Shopify's theme editor than binding only at first page load. */
    root.addEventListener('click', (event) => {
      const variantButton = event.target.closest('[data-rv-variant]');
      if (variantButton && root.contains(variantButton)) {
        event.preventDefault();
        selectVariant(variantButton);
      }
    });

    root.querySelector('[data-rv-scroll-atc]')?.addEventListener('click', () => {
      productForm?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  };

  const initAll = (scope = document) => {
    scope.querySelectorAll?.('[data-rv-root]').forEach(initRadianVortex);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(document), { once: true });
  } else {
    initAll(document);
  }

  /* Shopify theme editor can reload a section without reloading the whole page. */
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
